const { REACT_APP_API_URL, REACT_APP_WS_URL } = process.env;

export const GRAPHQL_ROUTE = `${REACT_APP_API_URL}/graphql`;
export const GRAPHQL_SUBSCRIPTIONS_ROUTE = `${REACT_APP_WS_URL}/graphql-subscriptions`;
export const SIGNIN_ROUTE = `${REACT_APP_API_URL}/auth/admin/signin`;
export const GET_ADMIN_FROM_INVITATION_ROUTE = `${REACT_APP_API_URL}/auth/admin/get_admin_from_invitation`;
export const FINISH_REGISTRATION_ROUTE = `${REACT_APP_API_URL}/auth/admin/finish_registration`;
export const RESET_PASSWORD_ROUTE = `${REACT_APP_API_URL}/auth/admin/reset_password`;
export const REQUEST_PASSWORD_RESET_ROUTE = `${REACT_APP_API_URL}/auth/admin/request_password_reset`;
